"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    themeColors,
    opDirection,
    direction
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    zIndex = 9999,
    isWithMask = false,
    btnOpenSpace,
    isOpen = false
  } = props;
  const {
    pxToRem,
    maskProps,
    getMeasurement
  } = (0, _hooks.useStylesUtils)();
  const ccExpandableButtonStyle = (0, _react.useMemo)(() => {
    const contentOpenProps = () => {
      const width = isOpen ? '100%' : pxToRem(43);
      const opacity = isOpen ? 1 : 0;
      const pointerEvents = isOpen ? 'all' : 'none';
      const paddingInlineStart = isOpen ? pxToRem(20) : 0;
      const paddingInlineEnd = isOpen ? pxToRem(55) : 0;
      return {
        width,
        opacity,
        pointerEvents,
        paddingInlineStart,
        paddingInlineEnd
      };
    };
    const btnOpenProps = () => {
      if (isOpen && btnOpenSpace) {
        return {
          padding: getMeasurement(btnOpenSpace)
        };
      }
      return {};
    };
    const btnMaskProps = () => {
      if (isWithMask) {
        return {
          zIndex: zIndex + 1
        };
      }
      return {};
    };
    const ccExpandableButtonMask = (0, _css.css)({
      ...maskProps(isOpen),
      zIndex: zIndex
    });
    const ccExpandableButton = (0, _css.css)({
      position: 'relative',
      direction: opDirection,
      ...btnMaskProps()
    });
    const ccExpandableButtonContent = (0, _css.css)({
      direction: direction,
      position: 'absolute',
      height: '100%',
      overflow: 'hidden',
      transition: 'width 0.5s ease-in-out, opacity 0.5s ease-in-out',
      borderRadius: pxToRem(25),
      border: `1px solid ${themeColors?.general.border}`,
      background: themeColors?.general.light,
      flex: 'none',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      boxSizing: 'border-box',
      ...contentOpenProps()
    });
    const ccExpandableButtonBtn = (0, _css.css)({
      textAlign: direction === 'rtl' ? 'left' : 'right',
      ...btnOpenProps()
    });
    return {
      ccExpandableButtonMask,
      ccExpandableButton,
      ccExpandableButtonContent,
      ccExpandableButtonBtn
    };
  }, [btnOpenSpace, direction, getMeasurement, isOpen, isWithMask, maskProps, opDirection, pxToRem, themeColors?.general.border, themeColors?.general.light, zIndex]);
  return {
    'cc-ExpandableButton-mask': ccExpandableButtonStyle.ccExpandableButtonMask,
    'cc-ExpandableButton': ccExpandableButtonStyle.ccExpandableButton,
    'cc-ExpandableButton__content': ccExpandableButtonStyle.ccExpandableButtonContent,
    'cc-ExpandableButton__btn': ccExpandableButtonStyle.ccExpandableButtonBtn
  };
};
var _default = exports.default = useStyles;